var _circle, _circle2, _circle3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartRecord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5015,
    cy: 52.4971,
    r: 52,
    fill: "#1D4EAF",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5015,
    cy: 52.4971,
    r: 45,
    fill: "#1D4EAF",
    fillOpacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5015,
    cy: 52.4971,
    r: 37,
    fill: "#1D4EAF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.3154 53.4095C64.3154 52.6954 63.7694 52.1494 63.0554 52.1494C62.3413 52.1494 61.7953 52.6954 61.7953 53.4095C61.7953 58.3237 57.8051 62.3139 52.8909 62.3139C47.9766 62.3139 43.9864 58.3237 43.9864 53.4095C43.9864 52.6954 43.4404 52.1494 42.7264 52.1494C42.0123 52.1494 41.4663 52.6954 41.4663 53.4095C41.4663 59.2478 45.8345 64.162 51.6308 64.792V68.1522H47.0526C46.3385 68.1522 45.7925 68.6982 45.7925 69.4123C45.7925 70.1263 46.3385 70.6723 47.0526 70.6723H58.7292C59.4432 70.6723 59.9892 70.1263 59.9892 69.4123C59.9892 68.6982 59.4432 68.1522 58.7292 68.1522H54.1509V64.792C59.9472 64.162 64.3154 59.2478 64.3154 53.4095Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8908 34.9707C49.0266 34.9707 45.8765 38.1209 45.8765 41.985V53.3676C45.8765 57.2738 49.0266 60.382 52.8908 60.424C56.755 60.424 59.9052 57.2738 59.9052 53.4096V41.985C59.9052 38.1209 56.755 34.9707 52.8908 34.9707Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartRecord);
export default __webpack_public_path__ + "static/media/start_record.80f1e01db859830cdc9de1f04d4b83e4.svg";
export { ForwardRef as ReactComponent };